import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const fastly = defineConnector({
  identifier: "fastly",
  name: "Fastly",
  tagLine: "Edge cloud and CDN platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.fastly\\.com/.*",
  auth: (app) => headerAuth([{ name: "Fastly-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your Fastly API token",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Fastly web interface](https://manage.fastly.com/account/personal/tokens), go to **Account > Personal API tokens** and create a new token with the scopes you need.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.fastly.com/current_user",
  },
});
